export const ScrollActive = () => {

  const $window = $(window);
  const heading = $('.js-heading');
  const images = $('.js-img');
  const offsetTop = 250;
  $window.scroll(function () {
    heading.each(function() {
      const id = ($(this).attr("href"));
      if ($("a").is(id)) {
        if ( $window.scrollTop() + offsetTop >= $(id ).offset().top) {
          heading.removeClass('active');
          $(id).addClass('active');
          images.removeClass('active');
          images.each(function () {
            if ($(this).data("id") === id)  {
              $(this).addClass('active');
            }
          });
        } else {
          $(id).removeClass('active');
        }
      }
    });
  });

};
